<template>
	<b-card-body class="row">
		<div class="col-12 col-md-6 col-lg-4 col-xl-3" v-for="(spells,spellLevel) in spellsKnown" :key="`spells-known-list-${level}-${spellLevel}`">
			<planned-level-spells-list v-if="spellsKnown[spellLevel] > 0" :level="level" :spellLevel="spellLevel" :spellsKnown="spellsKnown[spellLevel]"></planned-level-spells-list>
		</div>
	</b-card-body>
</template>

<script>
import PlannedLevelSpellsList from '@/components/planning/PlannedLevelSpellsList.vue'

export default {
	components: {
		PlannedLevelSpellsList,
	},
	props: [
		'level',
	],
	computed: {
		spellsKnown: function() {
			return this.$store.state.Character.Levels[this.level].Spells.Known
		},
	},
}
</script>

<style scoped>

</style>